import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { IAlerts } from 'src/app/models/IAlerts';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { IAttributes } from 'src/app/models/IAttributes';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material';
import { formatDate, DatePipe } from '@angular/common';
import { IRole } from 'src/app/models/IRole';
import { UserManagementService } from 'src/app/Services/UserManagement/user-management.service';

export interface PeriodicElement {
  alert: string;
  priority: string;
  EffectiveDate: string;
  ExprirationDate: string;
  Status: string;
}



@Component({
  selector: 'app-popup-alerts',
  templateUrl: './popup-alerts.component.html',
  styleUrls: ['./popup-alerts.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})


export class PopupAlertsComponent implements OnInit {
  // columnsToDisplay = ['alert', 'priority','EffectiveDate', 'ExprirationDate', 'Status'];
  columnsToDisplay = ['alertDetails', 'priority', 'effectiveDate', 'exprirationDate', 'alertStatus', 'displayRoleName'];
  headercolumnsToDisplay = ['Alert Details', 'Priority', 'Effective Date', 'Expiration Date', 'Status', 'Role'];
  //dataSource = ELEMENT_DATA;
  expandedElement: PeriodicElement | null;
  lstPopAlertsInfo: IAlerts[] = [];
  lstUpdatedPopAlertsInfo: IAlerts[] = [];
  alertId = 0;
  createdBy: string;
  createdOn: any;
  public lstAlertStatus: IAttributes[];
  public lstAlertPriority: IAttributes[];
  public lstAlertRoles: IRole[];
  isSavsdisable: boolean = true;


  public show: boolean = false;

  alertpopForm: FormGroup;
  submitted = false;
  alertsInfo: IAlerts;
  public date: any;
  public createddate: any;

  constructor(private formBuilder: FormBuilder
    , private sharedService: SharedService
    , private personalService: PersonalInfoService
    , private toastr: ToastrService
    , public datepipe: DatePipe
    , private userService: UserManagementService
    , public dialogRef: MatDialogRef<PopupAlertsComponent>
    , @Inject(MAT_DIALOG_DATA) public data: IAlerts[]) { }

  ngOnInit() {
    this.alertpopForm = this.formBuilder.group({

      alertdetail: [''],
      Scheduling: [''],
      Demographics: [''],
      //Clinical: [''],
      //Billing: [''],
      //Ma: [''],
      chkVisitNote: [''],
      chkOrNote: [''],
      chkRx: [''],
      chkOrder: [''],
      EffectiveDate: [''],
      ExpirationDate: [''],
      Priority: [''],
      Status: [''],
      roles: [''],
      isChkRoles: [''],
    });
    this.alertsDropdownBinding();
    this.lstPopAlertsInfo = this.data;
    this.DisableAllFormControls(this.alertpopForm);
    this.getRoles();
  }

  alertsDropdownBinding() {
    if (this.sharedService.lstattrbutes != null && this.sharedService.lstattrbutes.length > 0) {
      this.lstAlertPriority = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '15');
      this.lstAlertStatus = this.sharedService.lstattrbutes.filter((attr: IAttributes) => attr.attributeType === '20');
    }
  }
  getRoles() {
    this.userService.getRoles().subscribe(data => {
      var rolesall = data.filter(rol => rol.roleName != 'Patient');
      this.lstAlertRoles = rolesall;
    });
  }

  oncellclick(element: IAlerts) {
    this.show = false;
    this.alertpopForm.patchValue({
      alertdetail: element.alertDetails,
      Scheduling: element.isScheduling,
      Demographics: element.isDemographics,
      // Clinical: element.isClinical,
      //Billing: element.isBilling,
      //Ma: element.isMA,
      chkVisitNote: element.isVisitNote,
      chkOrNote: element.isOrNote,
      chkRx: element.isRx,
      chkOrder: element.isOrderNote,
      EffectiveDate: this.transformdate(element.effectiveDate),
      ExpirationDate: this.transformdate(element.exprirationDate),
      Priority: element.priorityId.toString(),
      Status: element.alertStatusId.toString(),
      isChkRoles: element.isRole,
      //roles: element.rolesName.toString(),
      roles: element.displayRoleName.toString(),
    });
    this.alertId = element.alertId;
    // this.createdBy = element.createdBy;

    this.date = element.createdOn;
    this.createddate = this.transform(this.date);
    this.createdBy = element.userName;
    this.createdOn = this.createddate;
  }

  transformdate(value: any): Date {
    var datePipe = new DatePipe("en-US");
    if (value && value != undefined) {
      try {
        value = datePipe.transform(value, 'MM/dd/yyyy');
      }
      catch (e) {
        if (value.indexOf("-") > -1) {
          const inputvalue = value.toString();
          const Dateval = inputvalue.split("-")[0];
          const monthval = inputvalue.split("-")[1];
          const other = inputvalue.split("-")[2];
          if (Dateval.length <= 2)
            value = monthval + "-" + Dateval + "-" + other;
          value = datePipe.transform(value, 'MM/dd/yyyy');
        }
      }
    }
    return value;
  }

  DisableAllFormControls(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.DisableAllFormControls(abstractControl);
      } else {
        abstractControl.disable();
      }
    });
  }

  getAlertsInfo() {

  }

  DismissAlert(ele: IAlerts) {
    // alert("hi "+ele.alertId);

    if (ele.alertId > 0) {
      this.alertsInfo = ele;
      this.alertsInfo.isDismiss = false;
      this.personalService.updateAlertsInfo(this.alertsInfo).subscribe((results: any) => {
        // this.result = results;
        this.show = false; this.expandedElement = null;
        // this.getAlertsInfo(CommonComponents.patientId);
        // this.alertId = 0;
        const removeindex = this.lstPopAlertsInfo.findIndex(x => x.alertId === ele.alertId);
        if (removeindex != -1)
          this.lstPopAlertsInfo.splice(removeindex, 1);
        this.toastr.success("Alert Dismissed successfully");
      });

    }
  }

  onCancelClick() {
    this.show = false;
    this.expandedElement = null;
  }

  onOkClick(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.submitted = true;

  }

  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }

}
